module.exports = __webpack_public_path__ + "img/3.18ad153.svg";